/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { IAttributeListItem, IEntityMappingEntry, ISearchAssignmentItem, ISearchAssignmentsAttributeFilterItem } from '../../models';
import { EntityIdGroup } from '../../utils';

export const enum EAttributeActions {
  LoadAttributes = '[Attribute] Load Attributes',
  LoadAttributesSuccess = '[Attribute] Load Attributes Success',
  LoadAttributesFailure = '[Attribute] Load Attributes Failure',
  SetSelectedAttributes = '[Attribute] Set Selected Attributes',
  RemoveSelectedAttributeValue = '[Attribute] Remove Selected Attribute Value',
  SearchAssignments = '[Attribute] Search Assignments',
  SearchAssignmentsSuccess = '[Attribute] Search Assignments Success',
  SearchAssignmentsFailure = '[Attribute] Search Assignments Failure',
  RetrySearchAssignments = '[Attribute] Retry Search Assignments',
  MapEntities = '[Attribute] Map Entities',
  UpdateEntityMappings = '[Attribute] Update Entity Mappings',
  MapEntitiesFailure = '[Attribute] Map Entities Failure',
  ClearAssignments = '[Attribute] Clear Assignments'
}

export class LoadAttributes implements Action {
  public readonly type = EAttributeActions.LoadAttributes;
}

export class LoadAttributesSuccess implements Action {
  public readonly type = EAttributeActions.LoadAttributesSuccess;

  constructor(public payload: IAttributeListItem[]) {}
}

export class LoadAttributesFailure implements Action {
  public readonly type = EAttributeActions.LoadAttributesFailure;
}

export class SetSelectedAttributes implements Action {
  public readonly type = EAttributeActions.SetSelectedAttributes;

  constructor(public payload: IAttributeListItem[]) {}
}

export class RemoveSelectedAttributeValue implements Action {
  public readonly type = EAttributeActions.RemoveSelectedAttributeValue;

  constructor(public payload: { attributeId: string; value: string }) {}
}

export class SearchAssignments implements Action {
  public readonly type = EAttributeActions.SearchAssignments;

  constructor(public payload: { attributeFilters: ISearchAssignmentsAttributeFilterItem[]; entityIds: EntityIdGroup[] }) {}
}

export class SearchAssignmentsSuccess implements Action {
  public readonly type = EAttributeActions.SearchAssignmentsSuccess;

  constructor(public payload: ISearchAssignmentItem[]) {}
}

export class SearchAssignmentsFailure implements Action {
  public readonly type = EAttributeActions.SearchAssignmentsFailure;
}

export class RetrySearchAssignments implements Action {
  public readonly type = EAttributeActions.RetrySearchAssignments;
}

export class MapEntities implements Action {
  public readonly type = EAttributeActions.MapEntities;

  constructor(public payload: { attributeFilters: ISearchAssignmentsAttributeFilterItem[]; legacyEntityIds: EntityIdGroup[] }) {}
}

export class UpdateEntityMappings implements Action {
  public readonly type = EAttributeActions.UpdateEntityMappings;

  constructor(public payload: IEntityMappingEntry[]) {}
}

export class MapEntitiesFailure implements Action {
  public readonly type = EAttributeActions.MapEntitiesFailure;
}

export class ClearAssignments implements Action {
  public readonly type = EAttributeActions.ClearAssignments;
}

export type AttributeActions =
  | LoadAttributes
  | LoadAttributesSuccess
  | LoadAttributesFailure
  | SetSelectedAttributes
  | RemoveSelectedAttributeValue
  | SearchAssignments
  | SearchAssignmentsSuccess
  | SearchAssignmentsFailure
  | RetrySearchAssignments
  | MapEntities
  | UpdateEntityMappings
  | MapEntitiesFailure
  | ClearAssignments;
